import { type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface PageHeaderProps {
  title: string;
  description?: string;
  backTo?: string;
  actions?: ReactNode;
}

export function PageHeader({ title, description, backTo, actions }: PageHeaderProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (backTo) {
      navigate(backTo);
    } else if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <header className="mb-8 flex items-start justify-between gap-4">
      <div className="flex items-start gap-3">
        <button
          type="button"
          onClick={handleBack}
          className="mt-1 flex h-7 w-7 items-center justify-center rounded-md border border-line-default text-ink-muted transition-colors hover:border-line-strong hover:text-ink-primary focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-brand-500/40 [body.paper_&]:border-stone-default [body.paper_&]:text-charcoal-muted [body.paper_&]:hover:border-stone-strong [body.paper_&]:hover:text-charcoal"
          aria-label="Go back"
          title="Back"
        >
          <svg className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12.5 4L6 10l6.5 6" />
          </svg>
        </button>
        <div>
          <h1 className="text-2xl font-semibold tracking-tight-ish text-ink-primary [body.paper_&]:text-charcoal">
            {title}
          </h1>
          {description && (
            <p className="mt-1 text-petit text-ink-muted [body.paper_&]:text-charcoal-muted">
              {description}
            </p>
          )}
        </div>
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </header>
  );
}
